"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_RATE_FAIL = exports.GET_SWAPPABLE_ASSETS_FAIL = exports.SAVE_ORDER_FAIL = exports.GET_ORDER_HISTORY_FAIL = exports.CREATE_ORDER_FAIL = exports.CREATE_QUOTE_FAIL = exports.GET_ORDER_FAIL = void 0;
exports.GET_ORDER_FAIL = 'Error fetching order';
exports.CREATE_QUOTE_FAIL = 'Error creating quote';
exports.CREATE_ORDER_FAIL = 'Error creating order';
exports.GET_ORDER_HISTORY_FAIL = 'Error fetching order history';
exports.SAVE_ORDER_FAIL = 'Error saving order';
exports.GET_SWAPPABLE_ASSETS_FAIL = 'Error fetching asset info';
exports.GET_RATE_FAIL = 'Error fetching rate';
